<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="12"
        md="12"
      >
        <ecommerce-statistics />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
          xl="6"
          md="6"
      >
        <outlet-performance-accrual />
      </b-col>
      <b-col
          xl="6"
          md="6"
      >
        <outlet-performance-redemption />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="12">
        <loyalty-stats />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import EcommerceMedal from './EcommerceMedal.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import EcommerceRevenueReport from './EcommerceRevenueReport.vue'
import EcommerceOrderChart from './EcommerceOrderChart.vue'
import EcommerceProfitChart from './EcommerceProfitChart.vue'
import EcommerceEarningsChart from './EcommerceEarningsChart.vue'
import EcommerceCompanyTable from './EcommerceCompanyTable.vue'
import EcommerceMeetup from './EcommerceMeetup.vue'
import EcommerceBrowserStates from './EcommerceBrowserStates.vue'
import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
import EcommerceTransactions from './EcommerceTransactions.vue'
import OutletPerformanceAccrual from './Orders.vue'
import OutletPerformanceRedemption from './Quotations.vue'
import LoyaltyStats from './TeamPerformance.vue';
import LoyaltyMembersSummary from './LoyaltyMembersSummary.vue'
import MerchantsSummary from './MerchantsSummary.vue'
import CustomerPerformanceAccrual from './CustomerPerformanceAccrual.vue'

export default {
  components: {
    BRow,
    BCol,

    EcommerceMedal,
    EcommerceStatistics,
    EcommerceRevenueReport,
    EcommerceOrderChart,
    EcommerceProfitChart,
    EcommerceEarningsChart,
    EcommerceCompanyTable,
    EcommerceMeetup,
    EcommerceBrowserStates,
    EcommerceGoalOverview,
    EcommerceTransactions,
    OutletPerformanceAccrual,
    OutletPerformanceRedemption,
    LoyaltyStats,
    LoyaltyMembersSummary,
    MerchantsSummary,
    CustomerPerformanceAccrual
  },
  data() {
    return {
      data: {},
    }
  },
  created() {
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
